export default __webpack_public_path__ + "static/media/WeatherReporting_08.09cda56a.png";